<template>
	<div class="loading">
		<img class="img" src="@/assets/img/ablanca.png">
		<loader object="#ffffff" color1="#ffffff" color2="#ffffff" size="3" speed="2" bg="#00b7bd" objectbg="#999793" opacity="10" name="circular" v-if="true">asdasd</loader>
		<div class="msg text-center">{{msg}}</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosSystem from '@/mixins/axiosSystem.js'
	export default {
		name: 'Loading',
		mixins: [mixin, axiosSystem],
		data() {
			return {
				msg: 'Cargando . . .'
			}
		},
		methods: {
			initModuleLocal() {
				console.clear()
				let token = localStorage.getItem('token')
				if(token == null || token == 'undefined' || token == undefined) {
					this.$router.push('/access')
				} else {
					this.checkOpenSubscriptionPeriod()				
				}
			},
			checkOpenSubscriptionPeriod() {
				this.setHeadersAuthorization(localStorage.getItem('token'))
				let url = this.getApiBackend + 'subscription/open'
				this.msg = 'Verificando periodos . . .'
				document.title = this.msg
				this.axiosSystem('POST', url, 'checkOpenSubscriptionPeriodResult', null)
			},
			checkOpenSubscriptionPeriodResult(response) {
				if(response.data.success) {
					this.setPeriod(response.data.data)
				}
				this.clientConnection()
			},
			checkOpenSubscriptionPeriodResultError(error) {
				console.log(error)
				this.clientConnection()	
			},
			clientConnection() {
				let url = this.getApiBackend + 'clientConnection'

				this.msg = 'Verificando permisos . . .'
				document.title = this.msg
				this.axiosSystem('POST', url, 'clientConnectionResult', null)
			},
			clientConnectionResult(response) {
				document.title = 'Suscripción ACES Chile'
				if(response.data.success == true) {
					this.setInitSystem(true)
					this.setClientSystem(response.data.data)
					let redirect = (localStorage.getItem('redirect') == null) ? '/' : localStorage.getItem('redirect')
					this.redirect()
				} else {
					this.$awn.alert('<div class="text-center">Hay problemas para establecer sus credenciales</div><div class="text-center">Por favor ingrese nuevamente sus datos</div>')
					this.$router.push('/access')
				}
			},
			clientConnectionResultError(error) {
				console.log(error)
			},
			redirect() {
				let redirect = (localStorage.getItem('redirect') != null) ? localStorage.getItem('redirect') : '/'
				localStorage.removeItem('redirect')
				setTimeout(() => {
					this.$router.push(redirect)
				}, 1000)
			},

		},
		mounted () {
			this.initModuleLocal()
		}
	}
</script>

<style>
.loading {
	background-color: #00b7bd;
	width: 100vw;
	height: 100vh;
	display: flex;
  justify-content: center;
}

.img {
	width: 70px;
	position: absolute;
	top: 46%;
}

.msg {
	position: absolute;
	top: 60%;
	color: #fff;
	font-size: 1.5em;
}
</style>
